import { Observable } from 'rxjs';
import { TypedFormGroup } from '../domain';
import { Controls, NonGroup } from '../domain/typed-form';
import { FormHelpers } from '../util-helpers/helpers';

export class TypedForm<FormType> {
  public controls: FormType extends NonGroup ? never : Controls<FormType>;
  private helpers = new FormHelpers();

  public constructor(
    public readonly group: TypedFormGroup<FormType>,
    initialValue: Partial<FormType> | Observable<Partial<FormType>>,
  ) {
    this.controls = group.controls;
    this.helpers.setInitialValue(initialValue, group);
  }

  public validate(): void {
    this.helpers.validateAllFormFields(this.group);
  }
}
